// ProductReviewCard.tsx
import React from "react";
import StarRating from "../StarsRating/StarRating";
import "./ProductReviewCard.css";

interface Review {
  review_text: string;
}

interface ProductReviewCardProps {
  sku: string;
  totalReviews: number;
  totalScore: number;
  reviews: Review[];
}

const ProductReviewCard: React.FC<ProductReviewCardProps> = ({
  sku,
  totalReviews,
  totalScore,
  reviews,
}) => {
  // Use the provided totalScore as the average rating
  const averageRating = totalScore;

  return (
    <div className="product-review-card">
      <h4 className="product-title">Product SKU: {sku}</h4>
      <div className="rating-summary">
        <StarRating score={averageRating} />
        <span className="average-rating">{averageRating.toFixed(1)} / 5</span>
      </div>
      <div className="review-summary">
        <span className="total-reviews">Total Reviews: {totalReviews}</span>
      </div>
      <ul className="review-list">
        {reviews.length > 0 ? (
          reviews.map((review, index) => (
            <li key={index} className="review-item">
              <p className="review-text">{review.review_text}</p>
            </li>
          ))
        ) : (
          <li className="review-item">
            <p className="review-text">No reviews available.</p>
          </li>
        )}
      </ul>
    </div>
  );
};

export default ProductReviewCard;
